import { toBigNumber } from "lib/Any64bitId";
import I18n from "lib/I18n";
import { ConfigInterface } from "./Config";
import { observable } from "mobx";

export interface FilterInterface {
  eventId: string;
  nsaId: string;
  deviceId2: string;
  serialNumber: string;
}

export class Filter {
  @observable accessor availableEnvs = ["dd1", "jd1"];
  @observable accessor envs: string[] = [];
  @observable accessor eventId = "";
  @observable accessor nsaId = "";
  @observable accessor deviceId2 = "";
  @observable accessor serialNumber = "";
  @observable accessor searchParams = "";
  @observable accessor nsaIdError = "";

  constructor() {
    const searchParams = new URLSearchParams(window.location.search);
    this.envs = searchParams.get("env")?.split(",") || [];
    this.eventId = searchParams.get("eventId") || "";
    this.nsaId = searchParams.get("nsaId") || "";
    this.deviceId2 = searchParams.get("deviceId2") || "";
    this.serialNumber = searchParams.get("serialNumber") || "";
    this.searchParams = searchParams.toString();
  }

  buildQuery(config: ConfigInterface) {
    const convert = (value: string) =>
      config.displayIdAsHex ? toBigNumber(value).toString() : value;
    const eventIdKey = config.eventIdExactMatch ? "eventIdEq" : "eventIdCont";
    return {
      [eventIdKey]: this.eventId,
      nsaIdEq: this.nsaId ? convert(this.nsaId) : undefined,
      deviceId2Eq: this.deviceId2 ? this.deviceId2 : undefined,
      serialNumberEq: this.serialNumber ? this.serialNumber : undefined,
      envIn: this.envs,
    };
  }

  validate(displayIdAsHex: boolean) {
    const isValid = (value: string) => {
      try {
        if (value === "") {
          return true;
        }
        if (displayIdAsHex) {
          toBigNumber(value).toString();
        }
      } catch (_) {
        return false;
      }
      return true;
    };

    if (isValid(this.nsaId)) {
      this.nsaIdError = "";
    } else {
      this.nsaIdError = I18n.t("raw_post_viewer.messages.invalid_filter");
    }
  }

  updateUrlParams() {
    const searchParams = new URLSearchParams();
    if (this.envs.length > 0) {
      searchParams.set("env", this.envs.join(","));
    }
    if (this.eventId) {
      searchParams.set("eventId", this.eventId);
    }
    if (this.nsaId) {
      searchParams.set("nsaId", this.nsaId);
    }
    if (this.deviceId2) {
      searchParams.set("deviceId2", this.deviceId2);
    }
    if (this.serialNumber) {
      searchParams.set("serialNumber", this.serialNumber);
    }
    this.searchParams = searchParams.toString();
  }

  clear() {
    this.envs = [];
    this.eventId = "";
    this.nsaId = "";
    this.deviceId2 = "";
    this.serialNumber = "";
    this.searchParams = "";
  }

  hasNsaIdError() {
    return this.nsaIdError === "" ? false : true;
  }

  hasError() {
    return this.hasNsaIdError();
  }
}
